import EfIcon from '@elem/ui/ef-icon';
import EfImgListA from '@elem/ui/ef-img-list-a';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTabHoverA from '@elem/ui/ef-tab-hover-a';
import { useProductStore } from '../../../ProductProvider';
import { IPageStatus } from '../../../config/IPageStatus';
import { PRODUCT_D3P } from '../../index';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { pageStatus } = useProductStore();
    const { t } = useLang('theProduct.SectionB');
    const { t: t2 } = useLang('theProduct');

    const itemsA = [
        {
            title: '',
            desc: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723002771726/d3p_01.jpg',
        },
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723002772524/d3p_02.jpg',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723002772697/d3p_03.jpg',
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723002772194/d3p_04.jpg',
        },
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723002771956/d3p_05.jpg',
        },
    ];

    const itemsB = [
        {
            tabName: '',
            pc: PRODUCT_D3P,
            label: pageStatus === IPageStatus.statusC ? '' : t('box1_label'),
            title: t('box1_title'),
            descList: [t('box1_desc1'), t('box1_desc2'), t('box1_desc3')],
            moreIcon: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721387712963/a1.png" />,
            moreLink: '#section-SectionG',
            moreText: pageStatus === IPageStatus.statusC ? t('box1_btn1_2') : t('box1_btn1'),
            moreDataLayer: [
                {
                    event: 'uaEvent',
                    event_name: 'click_anchor',
                    position: pageStatus === IPageStatus.statusC ? `${t('box1_title')}_${t2('SectionG.title2')}` : `${t('box1_title')}_${t2('SectionG.title')}`,
                    button_name: pageStatus === IPageStatus.statusC ? t('box1_btn1_2') : t('box1_btn1'),
                },
            ],
            buyIcon: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1721387747560/a2.png" />,
            buyLink: 'https://www.amazon.co.jp/dp/B0DB5WRJWN?ref=myi_title_dp',
            buyText: pageStatus === IPageStatus.statusC ? t('box1_btn2_2') : t('box1_btn2'),
            buyDataLayer: [
                {
                    event: 'uaEvent',
                    event_name: 'buy_on_amazon',
                    product_name: t('box1_title'),
                    button_name: pageStatus === IPageStatus.statusC ? t('box1_btn2_2') : t('box1_btn2'),
                    list_name: t('box1_title'),
                },
            ],
            buyBtnDisabled: pageStatus !== IPageStatus.statusC,
            tips: '*量販店販売開始は9月下旬頃予定、順次出荷',
        },
    ];

    return (
        <div className={styles.TheComp} id="section-SectionB">
            <EfSpec />
            <EfSection title={t('title')} desc={t('desc')} />
            <EfImgListA items={itemsA} />
            <EfTabHoverA items={itemsB} />
        </div>
    );
}
